import PhonesList from '@/components/phones/PhonesList'
import PhonesNew from '@/components/phones/PhonesNew'
import PhonesEdit from '@/components/phones/PhonesEdit'

export default [
  {
    path: '/phones',
    name: 'phones',
    component: PhonesList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phones/new',
    name: 'phonesNew',
    component: PhonesNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phones/:id/edit',
    name: 'phonesEdit',
    component: PhonesEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/phonesRoutes.js